export const test = [
  {
    id: 1,
    send: false,
    curator: 'Владимир Белоголовцев',
    merch: 'Толстовка',
    fio: 'Иванов Иван Иванович',
    index: '199178',
    country: 'Россия',
    city: 'Санкт-Петербург',
    address: 'наб. реки Смоленки, 35к1',
    tel: '+7 (999) 999 99 99',
  },
  {
    id: 2,
    send: true,
    curator: 'Владимир Белоголовцев',
    merch: 'Толстовка',
    fio: 'Иванов Иван Иванович',
    index: '199178',
    country: 'Россия',
    city: 'Санкт-Петербург',
    address: 'наб. реки Смоленки, 35к1',
    tel: '+7 (999) 999 99 99',
  },
  {
    id: 3,
    send: false,
    curator: 'Владимир Белоголовцев',
    merch: 'Толстовка',
    fio: 'Иванов Иван Иванович',
    index: '199178',
    country: 'Россия',
    city: 'Санкт-Петербург',
    address: 'наб. реки Смоленки, 35к1',
    tel: '+7 (999) 999 99 99',
  },
  {
    id: 4,
    send: true,
    curator: 'Владимир Белоголовцев',
    merch: 'Толстовка',
    fio: 'Иванов Иван Иванович',
    index: '199178',
    country: 'Россия',
    city: 'Санкт-Петербург',
    address: 'наб. реки Смоленки, 35к1',
    tel: '+7 (999) 999 99 99',
  },
  {
    id: 5,
    send: false,
    curator: 'Владимир Белоголовцев',
    merch: 'Толстовка',
    fio: 'Иванов Иван Иванович',
    index: '199178',
    country: 'Россия',
    city: 'Санкт-Петербург',
    address: 'наб. реки Смоленки, 35к1',
    tel: '+7 (999) 999 99 99',
  },
  {
    id: 6,
    send: false,
    curator: 'Владимир Белоголовцев',
    merch: 'Толстовка',
    fio: 'Иванов Иван Иванович',
    index: '199178',
    country: 'Россия',
    city: 'Санкт-Петербург',
    address: 'наб. реки Смоленки, 35к1',
    tel: '+7 (999) 999 99 99',
  },
  {
    id: 7,
    send: true,
    curator: 'Владимир Белоголовцев',
    merch: 'Толстовка',
    fio: 'Иванов Иван Иванович',
    index: '199178',
    country: 'Россия',
    city: 'Санкт-Петербург',
    address: 'наб. реки Смоленки, 35к1',
    tel: '+7 (999) 999 99 99',
  },
  {
    id: 8,
    send: false,
    curator: 'Владимир Белоголовцев',
    merch: 'Толстовка',
    fio: 'Иванов Иван Иванович',
    index: '199178',
    country: 'Россия',
    city: 'Санкт-Петербург',
    address: 'наб. реки Смоленки, 35к1',
    tel: '+7 (999) 999 99 99',
  },
  {
    id: 9,
    send: false,
    curator: 'Владимир Белоголовцев',
    merch: 'Толстовка',
    fio: 'Иванов Иван Иванович',
    index: '199178',
    country: 'Россия',
    city: 'Санкт-Петербург',
    address: 'наб. реки Смоленки, 35к1',
    tel: '+7 (999) 999 99 99',
  },
  {
    id: 10,
    send: false,
    curator: 'Владимир Белоголовцев',
    merch: 'Толстовка',
    fio: 'Иванов Иван Иванович',
    index: '199178',
    country: 'Россия',
    city: 'Санкт-Петербург',
    address: 'наб. реки Смоленки, 35к1',
    tel: '+7 (999) 999 99 99',
  },
];
